import React from 'react'
import { GridByMeeting } from './groupByMeeting'
import { GridByCategory } from './groupByCategory'
import NotesTable from '../needs/NotesTable'
import { useContext } from 'react'
import { ProjectContext } from '../../../context/ProjectContext'
import { DeleteNotesDialog } from '../needs/deleteNotesDialog'
import { createPortal } from 'react-dom'
import { EmptyState } from '../needs/EmptyState'

export function StickyGrid ({ groupNotesBy }) {
  const { 
    notes, 
    showDeleteNotesDialog, 
    setShowDeleteNotesDialog, 
    handleDeleteNotes, 
    selectedNotes,
    notesInputRef
  } = useContext(ProjectContext)

  const handleCreateNote = () => {
    if (notesInputRef) {
      notesInputRef.focus()
    }
  }

  if (!notes || notes.length === 0) {
    return <EmptyState onCreateNote={handleCreateNote} />
  }

  return (
    <>
      {groupNotesBy === 'meeting' && <GridByMeeting />}
      {groupNotesBy === 'category' && <GridByCategory />}
      {groupNotesBy === 'table' && <NotesTable notes={notes} />}
        
      {showDeleteNotesDialog &&
        createPortal(
          <DeleteNotesDialog
            handleDeleteNotes={handleDeleteNotes}
            notesCount={selectedNotes.length}
            handleClose={() => setShowDeleteNotesDialog(false)}
          />,
          document.body
        ) as React.ReactPortal}
    </>
  )
} 